import { menuRegistry } from '@/common/menu/menuRegistry';
import { registerRouteForModule } from '@/common/route/registerModules';
import router, { ROUTE_NAME_APPLE } from './router';

menuRegistry.registerMenu([
    {
        parent: 'ThirdParty',
        key: 'Apple',
        name: 'Apple',
        icon: 'fab fa-apple',
        route: { name: ROUTE_NAME_APPLE }
    }
]);

export default registerRouteForModule(router);
